module.exports = __webpack_public_path__ + "img/STBDLALA.5dd6a81b.jpg";